import { RecipeResult } from "../../../../api/recipeResults";
import { Recipe } from "../../../../api/recipeSimulator";
import { CHART_LABEL } from "../recipeImpactChart.constants";
import { ChartSourceData, ChartVariant, ImpactBreakdown } from "../recipeImpactChart.types";

/** Breakdown objects of variants that exist in both the results and the recipe. */
export const getValidVariantBreakdowns = (
  recipeResults: RecipeResult | undefined,
  originalRecipeData: Recipe | null
): ImpactBreakdown[] => {
  if (!recipeResults?.variantstotalImpacts || !originalRecipeData?.variants?.length) return [];

  const validNames = new Set(originalRecipeData.variants.map(variant => variant.variantName));

  return recipeResults.variantstotalImpacts
    .filter(variant => validNames.has(variant.variantName))
    .map(variant => variant.variantImpactBreakdown || {});
};

/**
 * Builds the chart columns: the baseline (always first) followed by every
 * selected variant that also exists in the recipe.
 */
export const buildVariantsToShow = ({
  recipeResults,
  originalRecipeData,
  selectedVariants
}: ChartSourceData): ChartVariant[] => {
  const baseline: ChartVariant = {
    variantName: CHART_LABEL.baseline,
    breakdown: recipeResults?.originalRecipeImpactBreakdown || {}
  };

  const variants = (recipeResults?.variantstotalImpacts || [])
    .filter(
      variant =>
        selectedVariants.some(selected => selected.id === variant._id) &&
        originalRecipeData?.variants?.some(orig => orig.variantName === variant.variantName)
    )
    .map(variant => ({
      variantName: variant.variantName.trim(),
      breakdown: variant.variantImpactBreakdown
    }));

  return [baseline, ...variants];
};
